var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "full-width no-padding-top",
      attrs: { id: "account-preferences" }
    },
    [
      _c("div", { staticClass: "container" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.questionnaire || _vm.question === 1,
                    expression: "!questionnaire || question === 1"
                  }
                ],
                staticClass: "question pref"
              },
              [
                _c("h3", [
                  _vm._v(
                    "Are you pregnant (or would you like postpartum support)?"
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "inline-fields",
                    attrs: { "data-children-count": "1" }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.preferences.pregnant,
                          expression: "preferences.pregnant"
                        }
                      ],
                      attrs: { type: "radio" },
                      domProps: {
                        value: true,
                        checked: _vm._q(_vm.preferences.pregnant, true)
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.preferences, "pregnant", true)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Yes")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "inline-fields",
                    attrs: { "data-children-count": "1" }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.preferences.pregnant,
                          expression: "preferences.pregnant"
                        }
                      ],
                      attrs: { type: "radio" },
                      domProps: {
                        value: false,
                        checked: _vm._q(_vm.preferences.pregnant, false)
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.preferences, "pregnant", false)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("No")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.preferences && _vm.preferences.pregnant,
                        expression: "preferences && preferences.pregnant"
                      }
                    ],
                    staticClass: "form-group"
                  },
                  [
                    _c("label", { attrs: { for: "due_date" } }, [
                      _vm._v(
                        "Congratulations! When is your due date (or the date you gave birth)?"
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.preferences.pregnant_due_date,
                          expression: "preferences.pregnant_due_date"
                        }
                      ],
                      attrs: {
                        type: "date",
                        min: "2020-01-01",
                        name: "pregnant_due_date"
                      },
                      domProps: { value: _vm.preferences.pregnant_due_date },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.preferences,
                            "pregnant_due_date",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.show_pregnancy_validation_message
                  ? _c("div", { staticClass: "validation-message" }, [
                      _vm._v("Please enter a valid due date")
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.questionnaire || _vm.question === 2,
                    expression: "!questionnaire || question === 2"
                  }
                ],
                staticClass: "question pref"
              },
              [
                _c("h3", [_vm._v("What are your dietary preferences?")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.dietary_preference_selected,
                        expression: "dietary_preference_selected"
                      }
                    ],
                    staticClass: "core-prevent-select2",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.dietary_preference_selected = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v("Include meat options")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.dietary_preferences, function(preference) {
                      return _c(
                        "option",
                        {
                          key: preference.term_id,
                          domProps: {
                            value: preference.term_id,
                            selected:
                              _vm.dietary_preference_selected ==
                              preference.term_id
                          }
                        },
                        [_vm._v(_vm._s(preference.name))]
                      )
                    })
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.questionnaire || _vm.question === 3,
                    expression: "!questionnaire || question === 3"
                  }
                ],
                staticClass: "question pref"
              },
              [
                _c("h3", [
                  _vm._v("Which cooking measurements do you want to use?")
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.units,
                        expression: "units"
                      }
                    ],
                    staticClass: "core-prevent-select2",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.units = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "metric" } }, [
                      _vm._v("Metric (g, mL, kg)")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "imperial" } }, [
                      _vm._v("Imperial (oz, lb)")
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _vm.questionnaire
              ? _c(
                  "button",
                  {
                    staticClass: "core-btn",
                    attrs: { disabled: _vm.thinking },
                    on: {
                      click: function($event) {
                        return _vm.prevQuestion()
                      }
                    }
                  },
                  [_vm._v("Previous")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.questionnaire
              ? _c(
                  "button",
                  {
                    staticClass: "core-btn",
                    attrs: { disabled: _vm.thinking },
                    on: {
                      click: function($event) {
                        return _vm.nextQuestion()
                      }
                    }
                  },
                  [_vm._v("Next")]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.questionnaire
              ? _c(
                  "button",
                  {
                    staticClass: "core-btn",
                    attrs: { disabled: _vm.thinking },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.saveDetails.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v("Save preferences")]
                )
              : _vm._e()
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row heading" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h2", [_vm._v("My preferences")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }